// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"527":"7f41797c","822":"5f5aa2e5"}[chunkId] + ".js";
};